import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type UseDeleteGovernmentAllocationDistributionProps = {
  onSuccess: () => void
  onError: (error: AxiosError) => void
}

export const useDeleteGovernmentAllocationDistribution = ({
  onSuccess,
  onError,
}: UseDeleteGovernmentAllocationDistributionProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deleteGovernmentAllocationDistribution'],
    mutationFn: async (distributionId?: string) => {
      return privateAxios.put(`/billing/government_allocation_distributions/${distributionId}/stale`)
    },
    onSuccess,
    onError,
  })
}
